import { render, staticRenderFns } from "./pointsNote.vue?vue&type=template&id=82da4e2c&"
import script from "./pointsNote.vue?vue&type=script&lang=ts&"
export * from "./pointsNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports